<template>
  <div
    class="gain__flapImage"
    :class="{
      'bg--dark': !inverse,
      'bg--light': inverse,
    }"
  >
    <h6
      class="gain__flapText"
      :class="{
        'color--dark': !inverse,
        'color--light': inverse,
      }"
    >
      <slot />
    </h6>
  </div>
</template>
<script>
export default {
  props: {
    titleText: String,
    inverse: {
      default: true,
    },
  },

  data() {
    return {
      something: true,
    };
  },
};
</script>
<style scoped>
.gain__flapImage {
  height: 76px;
  width: 100%;
  background-repeat: no-repeat;
  background-position: top center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg--dark {
  background-image: url("../../assets/image/about/flap.png");
}

.bg--light {
  background-image: url("../../assets/image/about/flap-light.png");
}

.gain__flapText {
  text-align: center;
  font-family: "Seravek-Medium";
  font-size: 32px;
  text-transform: uppercase;
  margin-bottom: 0;
}

.color--dark {
  color: var(--secondary-color);
}

.color--light {
  color: var(--para-color);
}

/* Mobiles (Portrait) */
@media (min-width: 320px) and (max-width: 480px) {
  .gain__flapImage {
    height: 60px;
  }

  .gain__flapText {
    font-size: 24px;
  }

  /* .how-we-make-it-happen-tabs .gain__flapImage{
    height: 60px;
  } */

  .how-we-make-it-happen-tabs .gain__flapText,
  .tangibleResult .gain__flapText {
    font-size: 20px;
    padding: 15px;
  }
  .bg--light,
  .bg--dark {
    background-size: cover;
  }
}

/* Low Resolution Tablets, Mobiles (Landscape) */
@media (min-width: 481px) and (max-width: 767px) {
  .gain__flapText {
    font-size: 24px;
  }
  .how-we-make-it-happen-tabs .gain__flapText,
  .tangibleResult .gain__flapText {
    font-size: 20px;
    padding: 15px;
  }
  .bg--light,
  .bg--dark {
    background-size: cover;
  }
}

/* Tablets, Ipads (portrait) */
@media (min-width: 768px) and (max-width: 1024px) {
  .gain__flapText{
    font-size: 28px;
  }
  
}
</style>